var _g, _g2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetInTouch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip0_187_1646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_187_1646",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 11,
    height: 11
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_4730_12645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.3301 9.5H9.33008V19.5H19.3301V9.5Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_187_1646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1631 10.3334H18.4964M18.4964 10.3334V18.6666M18.4964 10.3334L10.1631 18.6667",
    stroke: "black",
    strokeWidth: 1.5
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.3301 14.5C27.3301 7.3203 21.5098 1.5 14.3301 1.5C7.15038 1.5 1.33008 7.3203 1.33008 14.5C1.33008 21.6797 7.15038 27.5 14.3301 27.5C21.5098 27.5 27.3301 21.6797 27.3301 14.5Z",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_187_1646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 29,
    fill: "white",
    transform: "translate(0.330078)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetInTouch);
export default __webpack_public_path__ + "static/media/getInTouch.c302a97efaa8096836da5a9388bbd84d.svg";
export { ForwardRef as ReactComponent };